/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["ui-breadcrumbs{overflow:hidden;display:inline-block;padding-left:5px}ui-breadcrumbs .ui-breadcrumbs-path{display:inline-block;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-size:14px;margin-bottom:1px;line-height:24px}ui-breadcrumbs .ui-breadcrumbs-path .mat-icon{position:relative;top:7px;padding-right:1px;left:-2px}ui-breadcrumbs .ui-breadcrumbs-current-folder{font-weight:700;font-size:18px}"];
export { styles as styles };
